import React, { useEffect, useState } from 'react';
import { ReactComponent as WorkIcon } from 'assets/images/SVG/icons/work-icon.svg';
import { ReactComponent as PasswordExpiry } from 'assets/images/SVG/icons/password_expiry-icon.svg';
import { UserName, UserPageSidebarWrap, UserAction, EditUserLink } from './style';
import UserPageEditModal from 'component/modal_components/userPage_edit/edit_modal';
import { ReactComponent as UserIcon } from 'assets/images/SVG/icons/profile-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Logo } from 'pages/interface/style';
import { UserTopNavbar } from 'component/top_navbar/TopnavBar.style';
import { Link } from 'react-router-dom';
import { Modal } from 'antd';
import ChangePassword from 'component/modal_components/password/password_form';
import { getOverrideGlobalStatusforloginUser } from 'redux/slices/settingsSlice';

const UserPageSidebar = ({ changemodal, setChangemodal }) => {
  const username = localStorage.getItem('userName');
  const dn = localStorage.getItem('dn');
  const dispatch = useDispatch();
  const [userPageopen, setUserPageopen] = useState(false);
  const { userProfileSetting, changePassword, overrideGlobalStatusUser, domainsettingsDataUser } = useSelector(
    (state) => state.settings
  );
  const canChangePassword = overrideGlobalStatusUser?.settings
    ? domainsettingsDataUser?.changePassword ?? true
    : changePassword ?? true;
  const canUserEdit = overrideGlobalStatusUser?.settings
    ? domainsettingsDataUser?.userProfile ?? true
    : userProfileSetting ?? true;
  const { singleUserData } = useSelector((state) => state.getUsers);

  useEffect(() => {
    dispatch(getOverrideGlobalStatusforloginUser());
  }, []);

  const handleEditUser = async () => {
    if (singleUserData) {
      setUserPageopen(true);
    }
  };

  const handleClick = () => {
    setChangemodal(true);
  };
  const handleCancel = () => {
    setChangemodal(false);
  };

  return (
    <UserPageSidebarWrap className='af-userpage-sidewrap'>
      <div style={{ textAlign: 'center' }} className='af-userpage-logowrap'>
        <Logo className='af-userpage-logo' />
      </div>
      <UserName className='af-userpage-name-wrap'>
        <UserIcon style={{ fontSize: '100px' }} className='af-userpage-userIcon' />
        <h1 className='af-userpage-username'>Hello, {username}</h1>
      </UserName>
      {canUserEdit && (
        <UserAction className='af-userpage-user-action'>
          {userPageopen && (
            <UserPageEditModal
              dn={dn}
              userPageData={singleUserData}
              userPageopen={userPageopen}
              setUserPageopen={setUserPageopen}
            />
          )}
          <EditUserLink className='af-userpage-user-action-edit' onClick={handleEditUser}>
            Edit Profile
          </EditUserLink>
        </UserAction>
      )}
      <div style={{ textAlign: 'center' }} className='af-userpage-side-content-wrap'>
        <UserTopNavbar className='af-userpage-side-content-one-wrap'>
          <div style={{ display: 'flex' }} className='af-userpage-content-one'>
            <div style={{ marginTop: '5px' }} className='af-userpage-content-one-iconwrap'>
              <PasswordExpiry
                style={{ height: '32px', width: '32px', margin: '10px' }}
                className='af-userpage-content-one-icon'
              />
            </div>
            <div style={{ textAlign: 'left' }} className='af-userpage-content-one-labelwrap'>
              <div className='af-userpage-content-one-labelitems'>
                <p style={{ fontWeight: 'bold' }} className='af-userpage-content-one-pass-label'>
                  Password Status:
                </p>
                <p style={{ margin: '0px' }} className='af-userpage-content-one-expiry-label'>
                  {singleUserData && singleUserData.expire.replace(':', '')}
                </p>
              </div>
              {canChangePassword && !singleUserData?.userCannotChangePassword && (
                <div style={{ marginTop: '13px' }} className='af-userpage-content-one-change-wrap'>
                  <Link className='af-userpage-content-one-change-link' onClick={handleClick}>
                    Change Password
                  </Link>
                </div>
              )}
            </div>
          </div>
        </UserTopNavbar>
        {/* <UserTopNavbar className='af-userpage-content-second-wrap'>
          <div style={{ display: 'flex' }} className='af-userpage-content-second'>
            <div style={{ marginTop: '5px' }} className='af-userpage-content-second-iconwrap'>
              <WorkIcon
                style={{ height: '25px', width: '30px', margin: '10px' }}
                className='af-userpage-content-second-icon'
              />
            </div>
            <div style={{ textAlign: 'left' }} className='af-userpage-content-second-labelwrap'>
              <p style={{ fontWeight: 'bold' }} className='af-userpage-content-second-logon-label'>
                Last Logon:
              </p>
              <p style={{ margin: '0px' }} className='af-userpage-content-second-logondate-label'>
                {singleUserData && singleUserData.lastLogon}
              </p>
            </div>
          </div>
        </UserTopNavbar> */}
      </div>
      {changemodal && (
        <Modal open={changemodal} onCancel={handleCancel} footer={[null]} centered className='af-userpage-change-modal'>
          <ChangePassword
            changePassUser={username}
            setChangemodal={setChangemodal}
            changemodal={changemodal}
            userCancel={handleCancel}
          />
        </Modal>
      )}
    </UserPageSidebarWrap>
  );
};

export default UserPageSidebar;
